import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import Barcode from "react-barcode";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import SettingsIcon from "@mui/icons-material/Settings";
import { BarChart } from "@mui/icons-material";
const MainForm = ({
  title,
  barCode,
  url,
  handleEdit,
  handleMove,
  handleCart,
  handleChart,
}) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={1} sm={12}>
        <Typography variant="h6">{title}</Typography>
        <Avatar
          alt={title}
          src={url}
          sx={{ width: 200, height: 200, gap: 2, mt: 1, p: 2.5 }}
          style={{
            transform: "translate(118px, 0%)",
            top: "10px",
          }}
        />
        <div
          className="barcode"
          style={{
            top: "10px",
          }}
        >
          <Barcode value={barCode} sx={{ gap: 2, mt: 1 }} />
        </div>
      </Grid>
      <Grid item xs={1} sm={12}>
        <IconButton onClick={handleEdit}>
          <SettingsIcon sx={{ width: 40, height: 40 }} />
        </IconButton>
        <IconButton onClick={handleMove}>
          <MoveUpIcon sx={{ width: 40, height: 40 }} />
        </IconButton>
        <IconButton onClick={handleChart}>
          <BarChart sx={{ width: 40, height: 40 }} />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default MainForm;
